import React, { useContext, useState } from 'react'
import { BACKEND_URL } from '../../const/Constant'
import { store } from '../../components/HOC/State'
import { Parser } from 'html-to-react'
import styles from './imagesLibrary.module.css'

export default function ImagesItem({el, setShowModal, index, setCurrentIndex}) {
    const [showDescription, setShowDescription] = useState(false)

    const  {selectedLang} = useContext(store)

    const htmlParser = new Parser()

    const enter = () => {
        setShowDescription(true)
    }

    const leave = () => {
        setShowDescription(false)
    }

    const open = () => {
        setShowModal(true)
        setCurrentIndex(index)
    }

   
 
  return (
    <div className={styles['each-image-div']} onClick={open}>
        <div className={styles['image-descr-div']}>
            <img src={BACKEND_URL + el.image} alt='mergelyan-image'/>
        </div>
    </div>
  )
}
